/**
 * AUIPivot 2.5 License
 * AUISoft DEMO
 */
/* eslint-disable */
AUIPivotLicense =
	'eyJjdCI6Ii8zOXhTZnYxdVN5RlYxMWtycXdmcEk1SlM5SmpTMHVjcTh4czB3QVMxcGt3dUJ3TUVwTWRUeDR0Q0Q5dFBhSUp6Ty9UZ1Zka1FIS2tiMUY1SVVWZ2VSL2h5ZkRadTRCQ3Ard0NXRndlSGFibFpGcG11ZlZDenRsakJ3dGIwWEh3IiwiaXYiOiJlOGEyNzAzZWM3NDdjN2NkZDM4NzdiZmFhMDgxYjk3NSIsInMiOiJjYjQwMDg3NzFjNzM3YjE0In0=';
